import { postBiz, json } from '../core/coreapi';
import { IExecutiveReviewManager, IExecutiveReviewWorkbench } from './executiveReview.models';

const SERVICE = 'bieexecutivereview';

export const fetchExecutiveReviewManager = async (
  planningcycleid: number
): Promise<IExecutiveReviewManager> =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'manager',
      pci: planningcycleid,
    })
  );

export const fetchExecutiveReviewWorkbench = async (
  planningcycleid: number,
  executivereviewid?: number | null
): Promise<IExecutiveReviewWorkbench> =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'workbench',
      pci: planningcycleid,
      eri: executivereviewid ?? null,
    })
  );


export const selectExecutiveScenario = async (
  executivereviewid: number,
  simulationsubmissionid: number,
  scenarioid: number,
  simulationresultid?: number | null
) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'selectscenario',
      rid: executivereviewid,
      ssi: simulationsubmissionid,
      sci: scenarioid,
      sri: simulationresultid ?? null,
    })
  );

export const recommendExecutiveScenario = async (p: {
  planningcycleid: number;
  executivereviewid: number;
  simulationsubmissionid: number;
  scenarioid: number;
  simulationresultid?: number | null;
  reason: string;
  conditions?: string;
}) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'recommend',
      pci: p.planningcycleid,
      eri: p.executivereviewid,
      ssi: p.simulationsubmissionid,
      sci: p.scenarioid,
      sri: p.simulationresultid ?? null,
      rsn: p.reason,
      cnd: p.conditions ?? '',
    })
  );

export const returnExecutiveReview = async (p: {
  executivereviewid: number;
  simulationsubmissionid: number;
  categorycode: string;
  reason: string;
}) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'return',
      rid: p.executivereviewid,
      ssi: p.simulationsubmissionid,
      ctc: p.categorycode,
      rsn: p.reason,
    })
  );

export const initializeDeterminantBudget = async (planningcycleid: number, executivereviewid: number) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'initializedeterminantbudget',
      pci: planningcycleid,
      eri: executivereviewid,
    })
  );

export const saveExecutiveEvidence = async (p: {
  executivereviewid: number;
  evidence: any[];
  stamp?: number;
}) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'saveevidence',
      rid: p.executivereviewid,
      evd: p.evidence,
      stp: p.stamp ?? null,
    })
  );

export const saveExecutiveParticipants = async (p: {
  executivereviewid: number;
  participants: any[];
  stamp?: number;
}) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'saveparticipants',
      rid: p.executivereviewid,
      pts: p.participants,
      stp: p.stamp ?? null,
    })
  );

export const certifyExecutiveRecommendation = async (p: {
  executivereviewid: number;
  recommendationid: number;
  statement: string;
  meetingdate: string;
  stamp?: number;
}) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'certify',
      rid: p.executivereviewid,
      rci: p.recommendationid,
      stm: p.statement,
      mtd: p.meetingdate,
      stp: p.stamp ?? null,
    })
  );
  
export const revokeExecutiveCertification = async (p: {
  executivereviewid: number;
  reason: string;
  stamp?: number;
}) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'revokecertification',
      rid: p.executivereviewid,
      rsn: p.reason,
      stp: p.stamp ?? null,
    })
  );
